export default "__VITE_ASSET__Bs6J2QIf__"